import { useEffect, useState } from "react";

const APK_URL = "https://monitor.twin-tc.net/TWINTC-Monitor.apk";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function AppDownloadCard() {
  const [copied, setCopied] = useState(false);
  const [version, setVersion] = useState("1.2.0");

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/app-version`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d && d.version) setVersion(d.version);
      })
      .catch(() => {});
  }, []);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(APK_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      console.error("copy failed", e);
    }
  };

  return (
    <section className="card app-download-card" data-testid="app-download-card">
      <div className="card-head">
        <h2>📱 تطبيق TWIN TC LLC للأندرويد</h2>
        <span className="app-version-chip" data-testid="app-version-chip">v{version}</span>
      </div>
      <div className="app-download-body">
        <div className="app-download-info">
          <p className="tickets-sub">
            تطبيق أندرويد أصلي (Kotlin) بواجهات عصرية: مراقبة لحظية، جاهزية Ookla،
            قياس السرعة بزر GO، إشعارات لحظية عبر Firebase، تحديث تلقائي، عربي/إنجليزي، فاتح/داكن
          </p>
          <div className="app-download-actions">
            <a
              className="btn btn-primary"
              href={APK_URL}
              download
              data-testid="app-download-btn"
            >
              ⬇ تحميل التطبيق (APK)
            </a>
            <button
              className="btn btn-ghost btn-sm"
              onClick={copyLink}
              data-testid="app-copy-link-btn"
            >
              {copied ? "✓ تم النسخ!" : "🔗 نسخ الرابط"}
            </button>
          </div>
          <ul className="app-feature-list" data-testid="app-feature-list">
            <li>يعمل على أندرويد 8.0 وأحدث — موقّع رسمياً باسم الشركة</li>
            <li>سجّل الدخول بنفس حساب هذه اللوحة</li>
            <li>تنبيهات تلقائية عند أي عطل أو رد جديد من Ookla</li>
          </ul>
        </div>
        <div className="app-qr-box" data-testid="app-qr-box">
          <img src="/apk-qr.png" alt="QR code لتحميل التطبيق" className="app-qr-img" />
          <span className="app-qr-caption">امسح الرمز من هاتفك للتثبيت مباشرة</span>
        </div>
      </div>
    </section>
  );
}
